import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ERole } from '@cf/core';
import { TextComponent } from '@cf/shared/ui/typography';
import { IBookingMember } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-participant-list',
  imports: [CommonModule, NgxTolgeeModule, TextComponent, MatTooltipModule],
  templateUrl: './participant-list.component.html',
  styleUrls: ['./participant-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParticipantListComponent {
  @Input() hideParticipants = false;

  @Input() hideHeader = false;

  @Input({ required: false }) participants!: IBookingMember[];

  @Input() role!: ERole;

  @Input() participantsAmount?: number;

  protected readonly ERole = ERole;

  get totalParticipants() {
    if (this.participantsAmount) {
      return this.participantsAmount;
    }
    return this.participants.length;
  }
}
